import DiagnosisI from '@interfaces/patients/diagnosisI';
import { BaseStateI } from '@interfaces/redux/base-state';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPatientDiagnosis } from '@services/patients/diagnosis';

export interface PatientDiagnosesState extends BaseStateI {
    patientDiagnoses: DiagnosisI[] | null;
}

const fetchPatientDiagnoses = createAsyncThunk(
    'patient/fetchPatientDiagnoses',
    async (patientUsername: string, thunkAPI) => {
        const data = await getPatientDiagnosis(patientUsername);
        return data;
    }
);

const patientDiagnosesSlice = createSlice({
    name: 'patient-diagnoses',
    initialState: {
        error: null,
        patientDiagnoses: null,
        status: 'idle',
    } as PatientDiagnosesState,
    reducers: {
        resetPatientDiagnoses: (state) => {
            state.error = null;
            state.patientDiagnoses = null;
            state.status = 'idle';
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchPatientDiagnoses.pending, (state, action) => {
            state.status = 'loading';
        });
        builder.addCase(fetchPatientDiagnoses.rejected, (state, action) => {
            state.status = 'failed';
            state.error = action.error;
        });
        builder.addCase(fetchPatientDiagnoses.fulfilled, (state, action) => {
            state.status = 'succeeded';
            state.patientDiagnoses = action.payload;
        });
    },
});

export const { resetPatientDiagnoses } = patientDiagnosesSlice.actions;
export default patientDiagnosesSlice.reducer;
